import styled from 'styled-components';
export const AdditionalInfoWrapper = styled.span `
  font-size: 14px;
  padding-top: 4px;
  display: block;
  font-weight: normal;
`;
